import { render, staticRenderFns } from "./StudentEditCourseFieldsSlidebar.vue?vue&type=template&id=323dae39"
import script from "./StudentEditCourseFieldsSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentEditCourseFieldsSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports